import {
  PAYPAL_THEME,
  BodyText,
  Button,
  Row,
  Col,
  Container,
  HorizontalScrollDesktop,
} from '@paypalcorp/pp-react';
import React, { useState } from 'react';
import MediaQuery from 'react-responsive';

import { Title, Image, Slide } from './redux/components/styles/donation-steps';
import glamorous from 'glamorous';

const StepText = glamorous(BodyText)({
  textAlign: 'justify',
  paddingTop: 'unset',
  '& a': {
    color: PAYPAL_THEME.sysColorSecondaryMain,
    fontFamily: PAYPAL_THEME.sysTypographyBodyStrongFamily,
  },
});

const ButtonContainer = glamorous.div({
  textAlign: 'center',
  margin: '48px 0px',
  '@media(max-width: 1063px)': {
    margin: '24px 0px',
  },
});

export default function DonationSteps(props) {
  const [currentPage, setCurrentPage] = useState(1);
  const handlePageChange = (index) => {
    setCurrentPage(index);
  };

  const renderBig = (steps) => {
    const [step1, step2, step3] = steps.steps;
    return (
      <Row>
        <Col>
          <Title as='h2' size='sm'>
            {steps.title}
          </Title>
          <div className='row steps-section'>
            <div
              className='col-sm-4 link-override'
              style={{ textAlign: 'center' }}
            >
              <Image src={step1.image} alt='' style={{ maxHeight: '128px' }} />
              <BodyText as='p' size='md' className='step-text'>
                {step1.text}
              </BodyText>
            </div>
            <div
              className='col-sm-4 link-override'
              style={{ textAlign: 'center' }}
            >
              <Image src={step2.image} alt='' style={{ maxHeight: '128px' }} />
              <StepText
                as='p'
                size='md'
                dangerouslySetInnerHTML={{ __html: step2.text }}
              />
            </div>
            <div
              className='col-sm-4 link-override'
              style={{ textAlign: 'center' }}
            >
              <Image src={step3.image} alt='' style={{ maxHeight: '128px' }} />
              <StepText
                as='p'
                size='md'
                dangerouslySetInnerHTML={{ __html: step3.text }}
              />
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  const renderSmall = (steps) => {
    const renderCard = (item) => {
      const { image, text, index } = item;

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <div
            key={`donation-step-${index}`}
            style={{
              display: 'grid',
              width: '75%',
              minHeight: '370px',
            }}
          >
            <Image src={image} alt='' />
            <Slide>
              <StepText
                as='p'
                size='md'
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </Slide>
          </div>
        </div>
      );
    };

    return (
      <Container>
        <Title as='h2' size='md'>
          {steps.title}
        </Title>
        <HorizontalScrollDesktop
          items={steps.steps}
          renderItem={renderCard}
          numOfVisibleItems={1}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          prevPageLabel={props.i18n('label.donationStep-back')}
          nextPageLabel={props.i18n('label.donationStep-next')}
        />
      </Container>
    );
  };

  const renderButton = () => {
    return (
      <Button
        as='a'
        target='_blank'
        size='lg'
        primary
        href={props.i18n('label.donation-href')}
      >
        {props.i18n('label.donationStep-button')}
      </Button>
    );
  };

  const steps = {
    title: props.i18n('label.donationStep-title'),
    steps: [
      {
        index: 1,
        step: props.i18n('label.donationStep-step1'),
        text: props.i18n('label.donation-step1-text'),
        image: `https://${props.cdnHost}/paypal-ui/illustrations/focused/svg/find-a-charity.svg`,
      },
      {
        index: 2,
        step: props.i18n('label.donationStep-step2'),
        text: props.i18n('label.donation-step2-text'),
        image: `https://${props.cdnHost}/paypal-ui/illustrations/focused/svg/deliver-donation.svg`,
      },
      {
        index: 3,
        step: props.i18n('label.donationStep-step3'),
        text: props.i18n('label.donation-step3-text'),
        image: `https://${props.cdnHost}/paypal-ui/illustrations/focused/svg/donation-receipt.svg`,
      },
    ],
  };

  return (
    <div style={{ backgroundColor: PAYPAL_THEME.sysColorBackgroundMain }}>
      <Container>
        <MediaQuery minWidth={1064}>{renderBig(steps)}</MediaQuery>
        <MediaQuery maxWidth={1063}>{renderSmall(steps)}</MediaQuery>
        <Row>
          <Col>
            <ButtonContainer>{renderButton()}</ButtonContainer>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
